import PostDemandContent from './PostDemandContent';

export {
  PostDemandContent
};



// WEBPACK FOOTER //
// ./components/my-business/sub-view/post-demand-content/index.js